module.exports = __webpack_public_path__ + "static/EnvFollower_panel-1e162f627503801bb64a3d0c863d317b.png";